import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import Radio from "app/pages/.shared/form/Radio";
import PaymentCouponItem from "app/pages/Booking/Payment/PaymentCoupons/PaymentCouponItem/PaymentCouponItem";
import MoreDetails from "app/pages/.shared/MoreDetails";
import "../CreditRadio/CreditRadio.scss";
import { sendTagOnMoreDetailCreditNoteClick } from "app/utils/analytics";

const CreditNoteRadio = ({ value, usableCreditNotes, unusableCreditNotes }) => {
	const handleOnClick = useCallback(() => {
		sendTagOnMoreDetailCreditNoteClick();
	}, []);

	return (
		<Radio
			showIcon={true}
			name="credit-note-radio"
			id="credit-note-radio"
			checked={true}
			data-cy={`coupon-credit-note-input`}
			body={
				<div className="credit-radio__body">
					<MoreDetails
						headerPosition={"bottom"}
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
						onChange={handleOnClick}
					>
						{usableCreditNotes.map(usableCredit => {
							return (
								<div className="credit-radio__coupon-item" key={usableCredit.title}>
									<PaymentCouponItem
										friendEmail={usableCredit.friendEmail}
										amount={usableCredit.amount}
										creationDate={usableCredit.creationDate}
										balance={usableCredit.balance}
										uses={usableCredit.uses}
										maxUseDate={usableCredit.maxUseDate}
										conditions={usableCredit.conditions}
										usageRule={
											<FormattedMessage id="payment.coupons.credit.note.usage.rule" />
										}
										title={usableCredit.title}
										usableAmount={usableCredit.usableAmount}
									/>
								</div>
							);
						})}

						{unusableCreditNotes.map(unusableCredit => {
							return (
								<div
									className="credit-radio__coupon-item"
									key={unusableCredit.title}
								>
									<PaymentCouponItem
										disabled={true}
										friendEmail={unusableCredit.friendEmail}
										isApplicable={unusableCredit.isApplicable}
										amount={unusableCredit.amount}
										creationDate={unusableCredit.creationDate}
										balance={unusableCredit.balance}
										uses={unusableCredit.uses}
										maxUseDate={unusableCredit.maxUseDate}
										conditions={unusableCredit.conditions}
										title={unusableCredit.title}
										usableAmount={unusableCredit.usableAmount}
									/>
								</div>
							);
						})}
					</MoreDetails>
				</div>
			}
		>
			<div className="credit-radio__content">
				<div className="credit-radio__name">
					<FormattedMessage id="payment.coupons.input.creditnotes.label" />
				</div>
				<div className="credit-radio__amount">
					<AmountContainer amount={value} prefix={<AmountSign sign="-" />} />
				</div>
			</div>
		</Radio>
	);
};

CreditNoteRadio.propTypes = {
	value: PropTypes.number,
	usableCreditNotes: PropTypes.array,
	unusableCreditNotes: PropTypes.array,
};

CreditNoteRadio.defaultProps = {
	usableCreditNotes: [],
	unusableCreditNotes: [],
};

export default CreditNoteRadio;
